/* Baminger-Warenkorb: Gruppen und Cart-Transform-Bündel vollständig entfernen.
   Während einer Änderung bleiben weitere Entfernen-Aktionen gesperrt. */
(function () {
  if (window.__dsBamWarenkorb) return;
  window.__dsBamWarenkorb = true;
  var entfernt = false;

  document.addEventListener('click', async function (e) {
    var knopf = e.target && e.target.closest
      ? e.target.closest('[data-ds-bam-entfernen], [data-ds-bam-buendel-entfernen]') : null;
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    if (entfernt) return;

    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var buendel = knopf.getAttribute('data-ds-bam-buendel-entfernen');
    var gruppe = knopf.getAttribute('data-ds-bam-entfernen');
    var updates = {};
    if (!buendel) {
      document.querySelectorAll('tr[data-bam-gruppe]').forEach(function (zeile) {
        if (zeile.getAttribute('data-bam-gruppe') === gruppe) {
          updates[zeile.getAttribute('data-key')] = 0;
        }
      });
      if (!Object.keys(updates).length) return;
    }

    entfernt = true;
    var controls = Array.from(document.querySelectorAll(
      'cart-items-component button, cart-items-component input, #checkout'
    )).map(function (element) {
      var vorher = element.disabled;
      element.disabled = true;
      return {element: element, disabled: vorher};
    });
    var meldung = document.createElement('p');
    meldung.className = 'cart-item__error';
    meldung.setAttribute('role', 'status');
    meldung.textContent = 'Wird entfernt …';
    knopf.closest('td').appendChild(meldung);
    try {
      // Bündel immer über den eindeutigen Schlüssel entfernen: Nach einer
      // anderen Warenkorbänderung kann dieselbe Zeilennummer etwas anderes sein.
      var antwort = await fetch(wurzel + (buendel ? 'cart/change.js' : 'cart/update.js'), {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(buendel ? {id: buendel, quantity: 0} : {updates: updates})
      });
      var korb = await antwort.json();
      if (!antwort.ok || korb.errors || !Array.isArray(korb.items)) {
        throw new Error('Entfernen fehlgeschlagen');
      }
      var uebrig = korb.items.some(function (item) {
        return buendel ? item.key === buendel :
          (item.properties && item.properties._bam_gruppe === gruppe);
      });
      if (uebrig) throw new Error('Artikel wurde nicht entfernt');
      window.location.reload();
    } catch (error) {
      entfernt = false;
      controls.forEach(function (control) { control.element.disabled = control.disabled; });
      meldung.setAttribute('role', 'alert');
      meldung.textContent = 'Der Artikel konnte nicht entfernt werden. Bitte versuche es erneut.';
    }
  }, true);
})();
